import { Loading } from 'element-ui'

let loadingCount = 0
let loading

const startLoading = (title) => {
  loading = Loading.service({
    lock: true,
    text: `${title}……`,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

const endLoading = () => {
  loading.close()
}

export const showLoading = (title) => {
  if (loadingCount === 0) {
    startLoading(title)
  }
  loadingCount += 1
}

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return
  }
  loadingCount -= 1
  if (loadingCount === 0) {
    endLoading()
  }
}
